import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import RedlockConfigListing from './RedlockConfigListing'
import RedlockCredentialsForm from './RedlockCredentialsForm'

export default function RedlockPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={RedlockCredentialsForm}
            PullConfigListingView={RedlockConfigListing}
        />
    )
}